var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNextFiReverse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 673.31 673.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M336.65,673.31c-89.92,0-174.46-35.02-238.05-98.6S0,426.58,0,336.65,35.02,162.19,98.6,98.6C162.19,35.02,246.73,0,336.65,0s174.47,35.02,238.05,98.6c63.59,63.59,98.6,148.13,98.6,238.05s-35.02,174.47-98.6,238.05c-63.58,63.59-148.13,98.6-238.05,98.6ZM336.65,25C164.81,25,25,164.81,25,336.65s139.81,311.66,311.65,311.66,311.66-139.81,311.66-311.66S508.5,25,336.65,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M336.65,663.31c-87.25,0-169.28-33.98-230.98-95.68C43.98,505.94,10,423.91,10,336.65S43.98,167.37,105.67,105.67C167.37,43.98,249.4,10,336.65,10s169.28,33.98,230.98,95.67c61.7,61.7,95.68,143.73,95.68,230.98s-33.98,169.28-95.68,230.98c-61.7,61.7-143.73,95.68-230.98,95.68ZM336.65,15C159.29,15,15,159.29,15,336.65s144.29,321.66,321.65,321.66,321.66-144.29,321.66-321.66S514.02,15,336.65,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.55,127.89l-43.96,136.01c-.44,1.37.58,2.77,2.02,2.77l222.7-1.19c2.02-.01,2.88-2.58,1.26-3.8l-178.74-134.81c-1.16-.88-2.84-.35-3.29,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M495.27,266.89l-274.89,139.24c-.46.23-.81.64-.97,1.14l-44.1,137.09c-.53,1.64,1.19,3.1,2.72,2.32l273.4-138.59c.46-.23.8-.63.96-1.12l45.59-137.74c.54-1.64-1.17-3.12-2.72-2.34Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNextFiReverse);
export default __webpack_public_path__ + "static/media/icon-nextFi-reverse.26bd0944bc7bc6f2177b83798eecfc90.svg";
export { ForwardRef as ReactComponent };